/** 用于随机选的数字 */
const BASE_NUMBER = "0123456789";
/** 用于随机选的字符 */
const BASE_CHAR = "abcdefghijklmnopqrstuvwxyz";
/** 用于随机选的字符和数字 */
const BASE_CHAR_NUMBER = BASE_CHAR + BASE_NUMBER;

/**
 * 获得一个随机的字符串
 * @param baseString 随机字符选取的样本
 * @param length 字符串的长度
 * @returns {string} 随机字符串
 */
export const randomString = (baseString = BASE_CHAR_NUMBER, length = 6) => {
    let str = ''
    for (let i = 0; i < length; i++) {
        str += baseString.charAt(Math.floor(Math.random() * baseString.length))
    }
    return str
}

/**
 * 获得一个随机的字符串（只包含数字和大写字符）
 * @param length 字符串的长度
 * @returns {string} 随机字符串登录密码

 */
export const randomStringUpper = (length) => {
    return randomString(BASE_CHAR_NUMBER, length).toUpperCase()
}
